import { useMemo } from 'react'

import { FEATURE_FLAGS } from '@infura/packages.common/constants'
import { trackClickForSegmentAnalytics } from '@infura/packages.common/segmentAnalytics'
import { HeaderBanner } from 'components/banners/HeaderBanner'
import useVisibilityCookie from 'hooks/useVisibilityCookie'
import { useFlags } from 'launchdarkly-react-client-sdk'

const BANNER_ID = 'BURSTABLE_THROUGHPUT_ADDON_BANNER'

/**
 * Renders a banner which links to Burstable Throughput Addon
 */
export const BurstableThroughputAddonBanner = () => {
  const [shouldShowBanner, toggleBanner] = useVisibilityCookie(BANNER_ID)

  const flags = useFlags()
  const featureFlag = useMemo(() => flags[FEATURE_FLAGS.BURSTABLE_THROUGHPUT_ADDON_BANNER], [flags])

  if (!featureFlag) {
    return null
  }

  if (!shouldShowBanner) {
    return null
  }

  const text =
    'Now available: Burstable Throughput - Handle 10x more traffic without dropping a request. Enable burstable throughput'
  const link = '/billing/plan'

  const handleDismiss = () => {
    toggleBanner()
    trackClickForSegmentAnalytics({
      clickText: 'Dismiss',
      location: 'Burstable Throughput Addon Banner',
      type: 'Button'
    })
  }

  const handleClick = () => {
    trackClickForSegmentAnalytics({
      clickText: text,
      clickUrl: link,
      location: 'Burstable Throughput Addon Banner',
      type: 'Link'
    })
  }

  return (
    <HeaderBanner
      link={link}
      onClick={handleClick}
      onDismiss={handleDismiss}
      testId='burstable-throughput-addon-banner'
    >
      {text}
    </HeaderBanner>
  )
}
